import * as React from "react";
import Navigation from "../../components/Navigation";
import Footer from "../../components/Footer";
import { Box, useMediaQuery } from "@mui/material";
import theme from "../../components/styles/theme/theme";
import AdminPanel from "./components/AdminPanel";
import { loadUser } from "../../store/localStorage";

export const AdminPanelPage: React.FC = () => {
  const loggedUser = loadUser();
  const isSmScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return loggedUser?.isAdmin ? (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      <Navigation />
      <Box
        padding={`50px ${isSmScreen ? "16px" : "50px"}`}
        margin="auto"
        sx={{
          height: 800,
          width: "100%",
          "& .MuiOutlinedInput-notchedOutline": {
            display: "none",
          },
        }}
      >
        <AdminPanel />
      </Box>
      <Footer />
    </Box>
  ) : null;
};
